<form [formGroup]="searchMarknadsprislistaForm" (ngSubmit)="search()">
<div class="row">
    <rask-input class="col-2" aid="inputSearchViolId" label="Viol id" formControlName="violId"></rask-input>
    <rask-input class="col-2" aid="inputSearchBenamning" label="Benämning" formControlName="benamning"></rask-input>
    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
    @if (marknadsomrade != null) {
    <rask-multi-selector class="col-4"
        aid="inputResultatomraden"
        label="Region"
        [items]="getMarknadsomrade()"
        bindLabel="namn"
        groupBy="group"
        formControlName="resultatomraden"
        >
    </rask-multi-selector>
    }
    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
    @if (handelssortimentGrupper != null) {
    <rask-multi-selector class="col-4"
        aid="inputHandelssortimentsgrupper"
        label="Handelssortimentgrupp"
        [items]="getHandelssortimentsgrupper()"
        bindLabel="namn"
        formControlName="handelssortimentsgrupper">
    </rask-multi-selector>
    }
</div>
<div class="row">
    <rask-datepicker class="col-2"
    aid="searchInputGallerFrom"
    label="Fr o m"
    formControlName="gallerFrom"
    ></rask-datepicker>
    <rask-datepicker class="col-2"
    aid="searchInputGallerTom"
    label="T o m"
    formControlName="gallerTom"
    ></rask-datepicker>
    <rask-checkbox class="col-2" aid="searchInputIsAktuell" formControlName="isAktuell" label="Endast Aktuella"></rask-checkbox>
    <rask-radiobutton-group class="col-3" label="Används för" [buttons]="activetypes" formControlName="typ"></rask-radiobutton-group>
    <rask-submit-button
    class="col-3"
    aid="buttonSokMarknadsprislista"
    color="secondary">
    {{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}
    </rask-submit-button>
</div>
</form>
